var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
let Accordion = class Accordion extends Vue {
  constructor() {
    super(...arguments);
    // 当前是不是已经展开了
    this.acutalExpanded = true;
  }
  created() {
    this.isDesignMode = !!this.$attrs['data-uc-design-mode'];
    this.$watch(() => !!this.expanded, val => void (this.acutalExpanded = val), {
      immediate: true
    });
  }
  toggle() {
    const expanded = !this.acutalExpanded;
    this.acutalExpanded = expanded;
    this.$emit('change', expanded);
    if (expanded) this.$emit('expand');else this.$emit('collapse');
  }
  handleHeaderClick(e) {
    const actions = this.$refs.actions;
    if (e.target === actions || actions !== null && actions !== void 0 && actions.contains(e.target)) return;
    this.toggle();
  }
  renderTitle() {
    const h = this.$createElement;
    const {
      title
    } = this.$slots;
    if (title) {
      return title;
    }
    return h("div", {
      "class": "w-accordion-title"
    }, [this.title]);
  }
  render() {
    const h = arguments[0];
    const {
      isDesignMode,
      acutalExpanded
    } = this;
    return h("div", {
      "class": `w-accordion ${acutalExpanded ? 'isExpanded' : 'isCollapsed'} ${this.isCompact ? 'isCompact' : ''}`
    }, [h("div", {
      "class": "w-accordion-header",
      "on": {
        "click": this.handleHeaderClick
      }
    }, [h("i", {
      "class": `w-accordion-toggleIcon fa fa-chevron-${acutalExpanded ? 'down' : 'right'}`,
      "attrs": {
        "aria-hidden": "true"
      }
    }), this.renderTitle(), (isDesignMode || !!this.$slots.action) && h("div", {
      "class": "w-accordion-actions uc-slotForBlocks",
      "ref": "actions"
    }, [this.$slots.action])]), h("div", {
      "class": "w-accordion-contentWrapper",
      "directives": [{
        name: "show",
        value: isDesignMode || this.acutalExpanded
      }]
    }, [h("div", {
      "class": "w-accordion-content uc-slotForBlocks",
      "ref": "content"
    }, [this.$slots.default || h("div", {
      "class": "w-accordion-emptyPlaceholder"
    }, ["\u7A7A\u767D"])])])]);
  }
};
Accordion = __decorate([Component({
  name: 'WAccordion',
  props: {
    title: {
      type: String,
      required: true
    },
    expanded: {
      type: Boolean,
      default: true
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'expanded',
    event: 'change'
  }
})], Accordion);
export default Accordion;
//# sourceMappingURL=index.js.map
